module.exports = __webpack_public_path__ + "static/media/icn_upload_form_16.5ab9ac82.svg";